"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const InverseLabel = ({ children, title }) => {
    return (React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        } },
        React.createElement(src_1.Text, { text: title, label: true, size: "large", textStyle: {
                color: src_1.steel,
            } }),
        children));
};
exports.default = InverseLabel;
